import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * PrivacyPolicy.tsx
 * SEO meta tags handled via react-helmet-async (already wired in App.tsx via HelmetProvider).
 */
const PrivacyPolicy: React.FC = () => (
  <>
    <Helmet>
      <title>Privacy Policy | Chart2Video</title>
      <meta name="description" content="Chart2Video privacy policy — how we collect, use, and protect your data." />
      <link rel="canonical" href="https://www.chart2video.com/privacy" />
    </Helmet>

    <div className="privacy-policy max-w-3xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
      <p>Last Updated: March 18, 2025</p>

      <p className="mt-4">
        Welcome to <strong>Chart2Video</strong> (the "Service"). This Privacy Policy explains how
        we collect, use, disclose, and safeguard your information when you use our web application.
        By accessing or using Chart2Video, you agree to the terms of this Privacy Policy.
      </p>

      <h2 className="text-xl font-semibold mt-6">1. Information We Collect</h2>
      <p><strong>a. Personal Data:</strong> We may collect personally identifiable information (e.g., your email address) only if you voluntarily submit it, such as when signing up.</p>
      <p><strong>b. Usage Data:</strong> We automatically collect device and usage information, including IP address, browser type, OS, and pages visited via Google Analytics.</p>

      <h2 className="text-xl font-semibold mt-6">2. How We Use Your Information</h2>
      <ul className="list-disc list-inside">
        <li>Provide and improve the functionality and performance of our Service.</li>
        <li>Analyze trends and user behavior to enhance user experience.</li>
        <li>Respond to inquiries and provide customer support.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6">3. Cookies and Tracking Technologies</h2>
      <p>Our Service may use cookies and similar tracking technologies. You can refuse cookies via your browser settings; however, doing so might limit some functionality.</p>

      <h2 className="text-xl font-semibold mt-6">4. Disclosure of Your Information</h2>
      <p>We do not sell or rent your personal information. We may share data with third-party service providers solely as necessary to provide services to us.</p>

      <h2 className="text-xl font-semibold mt-6">5. Data Security</h2>
      <p>We use commercially reasonable measures to secure personal information. No method of transmission or storage is 100% secure.</p>

      <h2 className="text-xl font-semibold mt-6">6. Children's Privacy</h2>
      <p>We do not knowingly collect personal information from anyone under 13. Contact us immediately if you believe we have done so.</p>

      <h2 className="text-xl font-semibold mt-6">7. Third-Party Links</h2>
      <p>Our Service may link to third-party websites we do not control. Review those sites' privacy policies independently.</p>

      <h2 className="text-xl font-semibold mt-6">8. Changes to This Policy</h2>
      <p>We reserve the right to update this Privacy Policy at any time. Continued use constitutes acceptance of the updated policy.</p>

      <h2 className="text-xl font-semibold mt-6">9. Contact Us</h2>
      <p>
        Questions? Contact us at{' '}
        <a href="mailto:info@chart2video.com" className="text-blue-500">info@chart2video.com</a>.
      </p>
    </div>
  </>
);

export default PrivacyPolicy;